import { render, staticRenderFns } from "./valeShow.vue?vue&type=template&id=8dc1370a&"
import script from "./valeShow.vue?vue&type=script&lang=js&"
export * from "./valeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports